import { render, staticRenderFns } from "./Adventures2Main.vue?vue&type=template&id=5612b045&scoped=true&"
import script from "./Adventures2Main.vue?vue&type=script&lang=js&"
export * from "./Adventures2Main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5612b045",
  null
  
)

export default component.exports